/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'OCCUPATIONAL_HEALTH_AND_SAFETY_LAWS',
              'GENERAL_WORK_ENVIRONMENT_I_E_VENTILATION_CLEANLINESS_NOISE_ETC_',
              'BUILDING_SAFETY',
              'POWERED_MOTOR_VEHICLES_PMV_PROCEDURES',
              'EMERGENCY_PREPAREDNESS',
              'CHEMICALS_HAZARDOUS_SUBSTANCES',
              'NANOMATERIALS',
              'WORKER_PROTECTION_PERSONAL_PROTECTIVE_EQUIPMENT_MACHINERY_AND_E',
              'PRESSURE_VESSELS_SAFETY',
              'MATERIALS_HANDLING_AND_STORAGE',
              'ABOVE_GROUND_STORAGE_TANKS_UNDERGROUND_STORAGE_TANKS',
              'ELECTRICAL_SAFETY',
              'FIRST_AID_MEDICAL',
              'BLOODBORNE_PATHOGENS_PROCEDURES',
              'CONTRACTOR_SAFETY',
              'DORMITORIES',
              'CANTEENS',
              'CHILDCARE',
              'STANDARD_OPERATING_PROCEDURES_SOPS_FOR_HOW_TO_PERFORM_EACH_JOB_',
              'STEPS_FOR_WORKERS_TO_RAISE_HEALTH_AND_SAFETY_CONCERNS',
              'PROTECTION_AGAINST_RETALIATION_FOR_WORKERS_WHO_RAISE_HEALTH_AND',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_are_included_win_the_facs_written_10: valueSchema,
  },
}
